import React from "react";
import { styles, MarjInput } from "./adminStyles";

/**
 * HAS modu render bloku
 * Hesaplama backend'de yapilir, bu sadece pure form input rendering.
 */
const HasInputs = ({
  isDesktop,
  priceSource,
  hasSettings,
  handleHasChange,
}) => {
  const sectionRow = isDesktop
    ? { ...styles.section, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }
    : styles.section;
  const sectionH3 = isDesktop
    ? { margin: 0, minWidth: '180px', fontSize: '16px', whiteSpace: 'nowrap', fontWeight: 'bold' }
    : {};

  return (
    <>
      <h2 style={{color: '#DA9F54', textAlign: 'center', marginBottom: '20px', fontSize: '18px'}}>HAS Modu Ayarlari</h2>
      <div style={sectionRow}><h3 style={sectionH3}>Has Altin (TL)</h3><MarjInput label="Alis" marjKey="has_alis" value={hasSettings.has_alis} onChange={handleHasChange} /><MarjInput label="Satis" marjKey="has_satis" value={hasSettings.has_satis} onChange={handleHasChange} /></div>
      {priceSource !== 'altinkaynak' && <div style={sectionRow}><h3 style={sectionH3}>22 Ayar (Bilezik)</h3><MarjInput label="Carpan" marjKey="bilezik_carpan" value={hasSettings.bilezik_carpan} onChange={handleHasChange} /></div>}
      <h3 style={{ color: '#DA9F54', textAlign: 'center', margin: '25px 0 15px', fontSize: '16px', borderTop: '2px solid #DA9F54', paddingTop: '20px' }}>Gram (Milyem x Has Satis + Marj)</h3>
      <div style={styles.section}>
        <h3>1 Gram</h3>
        <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '8px 0 4px' }}>SATIS</p>
        <MarjInput label="Milyem" marjKey="gram_1_satis_has" value={hasSettings.gram_1_satis_has} onChange={handleHasChange} />
        <MarjInput label="Marj" marjKey="gram_1_satis_marj" value={hasSettings.gram_1_satis_marj} onChange={handleHasChange} />
        <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '12px 0 4px' }}>ALIS</p>
        <MarjInput label="Milyem" marjKey="gram_1_alis_has" value={hasSettings.gram_1_alis_has} onChange={handleHasChange} />
        <MarjInput label="Marj" marjKey="gram_1_alis_marj" value={hasSettings.gram_1_alis_marj} onChange={handleHasChange} />
      </div>
      <div style={styles.section}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
          <h3 style={{ margin: 0 }}>5-10-20 Gram</h3>
          <button onClick={() => handleHasChange('gram_separate', !hasSettings.gram_separate)} data-testid="gram-separate-toggle"
            style={{ padding: '6px 16px', fontSize: '13px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer', backgroundColor: hasSettings.gram_separate ? '#e74c3c' : '#27ae60', color: '#fff', border: 'none' }}>
            {hasSettings.gram_separate ? 'AYRI' : 'BIRLESIK'}
          </button>
        </div>
        {!hasSettings.gram_separate ? (
          <>
            <MarjInput label="Satis Milyem (5-10-20)" marjKey="gram_5_10_20_satis_has" value={hasSettings.gram_5_10_20_satis_has} onChange={handleHasChange} />
            <MarjInput label="Satis Marj (5-10-20)" marjKey="gram_5_10_20_satis_marj" value={hasSettings.gram_5_10_20_satis_marj} onChange={handleHasChange} />
          </>
        ) : (
          <>
            {[5, 10, 20].map(g => (
              <div key={g} style={{ marginBottom: '10px', padding: '8px', backgroundColor: '#f8f8f8', borderRadius: '8px' }}>
                <p style={{ fontWeight: 'bold', fontSize: '13px', marginBottom: '5px' }}>{g} Gram</p>
                <MarjInput label="Satis Milyem" marjKey={`gram_${g}_satis_has`} value={hasSettings[`gram_${g}_satis_has`]} onChange={handleHasChange} />
                <MarjInput label="Satis Marj" marjKey={`gram_${g}_satis_marj`} value={hasSettings[`gram_${g}_satis_marj`]} onChange={handleHasChange} />
              </div>
            ))}
          </>
        )}
      </div>
      <h3 style={{ color: '#DA9F54', textAlign: 'center', margin: '25px 0 15px', fontSize: '16px', borderTop: '2px solid #DA9F54', paddingTop: '20px' }}>Sarrafiye (HAS x Has Satis + Marj)</h3>
      {[
        { key: 'ceyrek', name: 'Ceyrek' }, { key: 'yarim', name: 'Yarim' },
        { key: 'teklik', name: 'Teklik' }, { key: 'ata_lira', name: 'Ata Lira' },
        { key: 'gremse', name: 'Gremse' },
      ].map(item => (
        <div key={item.key} style={styles.section}>
          <h3>{item.name}</h3>
          <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '8px 0 4px' }}>SATIS</p>
          <MarjInput label="HAS" marjKey={`${item.key}_satis_has`} value={hasSettings[`${item.key}_satis_has`]} onChange={handleHasChange} />
          <MarjInput label="Marj" marjKey={`${item.key}_satis_marj`} value={hasSettings[`${item.key}_satis_marj`]} onChange={handleHasChange} />
          <p style={{ fontWeight: 'bold', fontSize: '12px', color: '#DA9F54', margin: '12px 0 4px' }}>ALIS</p>
          <MarjInput label="HAS" marjKey={`${item.key}_alis_has`} value={hasSettings[`${item.key}_alis_has`]} onChange={handleHasChange} />
          <MarjInput label="Marj" marjKey={`${item.key}_alis_marj`} value={hasSettings[`${item.key}_alis_marj`]} onChange={handleHasChange} />
        </div>
      ))}
    </>
  );
};

export default HasInputs;
